import { ReactElement } from 'react';
import { toCurrency } from 'utils/numbers';

import OrderHistoryMenu from 'models/OrderHistoryMenu';
import type { MealSummary } from 'models/OrderHistoryMenu';
import ColoradoRDFLine from '../../Cart/shared/ColoradoRDFLine';

type Props = { item: OrderHistoryMenu; };

function SummarySection(label: string, value: number | string) {
  return (
    <div className="d-flex align-items-baseline justify-content-between">
      <div>{label}</div>
      <div className="c-order-details__hr" />
      <div>{value}</div>
    </div>
  );
}

function OrderSummary({ item }: Props): ReactElement {
  const {
    total_price: totalPrice,
    shipping_fee: shippingFee,
    shipping_surcharge: shippingSurcharge,
    crd_fee: crdFee,
    discount_value: discountValue,
    meals_summaries: mealsSummaries,
    refunded_amount: refundedAmount,
  } = item;

  return (
    <div className="col-12 col-sm-4 c-order-details__summary">
      <span className="c-heading c-heading--brand-8">ORDER SUMMARY</span>

      <div className="u-text u-text--md">
        {mealsSummaries.map((summary: MealSummary, index) => {
          if (summary.count <= 0) return '';

          return (
            <div
              key={summary.name}
              className="d-flex align-items-baseline justify-content-between"
            >
              <div>
                {`${summary.count} ${summary.name}`}
              </div>
              <div className="c-order-details__hr" />
              <div>{toCurrency(summary.price)}</div>
            </div>
          );
        })}

        {SummarySection('Sales Tax', toCurrency(item.sales_tax))}

        {!!crdFee && ColoradoRDFLine(Number(crdFee))}

        {!!shippingFee
          && SummarySection('Shipping', toCurrency(shippingFee))}

        {!!shippingSurcharge
              && SummarySection('Extended Area Surcharge', toCurrency(shippingSurcharge))}

        {!!Number(discountValue)
          && SummarySection('Discount', toCurrency(-discountValue))}

        {Number(refundedAmount) !== 0
          && SummarySection('Refund', toCurrency(-Number(refundedAmount)))}

        <div className="d-flex align-items-baseline justify-content-between">
          <div><strong>Total</strong></div>
          <div className="c-order-details__hr" />
          <div><strong>{toCurrency(totalPrice)}</strong></div>
        </div>
      </div>
    </div>
  );
}

export default OrderSummary;
